module.exports = __webpack_public_path__ + "static/IOBuilders-b06050f0f6c91500c5e18a2cc6a99e2e.png";